import { render, staticRenderFns } from "./SingleBillReport.vue?vue&type=template&id=56285bd4&"
import script from "./SingleBillReport.vue?vue&type=script&lang=js&"
export * from "./SingleBillReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports